import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#65C3FF', cx: '12', cy: '12', r: '12' }),
    React.createElement("path", { key: '1', fill: '#FFFFFF', d: 'M12,4.8c-0.7,0.7-4.2,6.6-4.2,8.2c0,2.3,1.8,4.2,4.2,4.2s4.2-1.8,4.2-4.2C16.2,11.4,12.7,5.5,12,4.8z' }),
], 'TransportConditionGeofencePouring');
const TransportConditionGeofencePouringIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportConditionGeofencePouringIcon);
